import { INIT_STATE } from "./state";
import { createSelector } from "reselect";

const selectAccount = (state) => state.accountReducer || INIT_STATE;

const selectListAccount = createSelector(selectAccount, (state) => state.listAccount || {});

export {
    selectListAccount,
}